import { InjectionToken } from '@angular/core';
import { Display } from 'src/app/api/services/display';
import { FolderOperationService } from 'src/app/api/services/folder-operation.service';
import { FolderService } from 'src/app/shared/services/folder.service';
import { DisplayService } from '../services/display.service';

export const provideDisplayFolderOperationService = () => ({
  provide: DISPLAY_FOLDER_OPERATION_SERVICE,
  useFactory: (
    folderService: FolderService,
    displayService: DisplayService,
  ) => {
    return new FolderOperationService(folderService, displayService);
  },
  deps: [FolderService, 'HasFolderStructure'],
});

export const DISPLAY_FOLDER_OPERATION_SERVICE = new InjectionToken<
  FolderOperationService<Display>
>('DISPLAY_FOLDER_OPERATION_SERVICE');
